// Calm prompts from real players: a ride offer or an invite to their place. Small cards, not
// blocking popups; they expire on their own if you ignore them.
import { useEffect } from "preact/hooks";
import { answerRide, inviteOffer, rideOffer } from "../../net/island";
import { getApartment } from "../../net/apartments";
import { showToast, world } from "../bridge";

const EXPIRE_MS = 20_000;

export function IslandPrompts() {
  const ride = rideOffer.value;
  const inv = inviteOffer.value;
  useEffect(() => {
    if (!ride) return;
    const t = setTimeout(() => answerRide(false), EXPIRE_MS);
    return () => clearTimeout(t);
  }, [ride]);
  useEffect(() => {
    if (!inv) return;
    const t = setTimeout(() => (inviteOffer.value = null), EXPIRE_MS);
    return () => clearTimeout(t);
  }, [inv]);
  if (ride)
    return (
      <div class="island-prompt" role="dialog" aria-label="Ride offer">
        <span>
          🚗 <b>@{ride.handle}</b> is offering you a ride.
        </span>
        <div class="row">
          <button class="btn primary" onClick={() => answerRide(true)}>
            Hop in
          </button>
          <button class="btn ghost" onClick={() => answerRide(false)}>
            No thanks
          </button>
        </div>
      </div>
    );
  if (inv)
    return (
      <div class="island-prompt" role="dialog" aria-label="Invite">
        <span>
          🏠 <b>@{inv.handle}</b> invited you to their place.
        </span>
        <div class="row">
          <button
            class="btn primary"
            onClick={async () => {
              inviteOffer.value = null;
              const apt = await getApartment(inv.handle).catch(() => null);
              if (!apt) return showToast(`@${inv.handle}'s place isn't open to visitors yet.`);
              world()?.visitHouse(apt.houseId, apt.layout, apt.handle);
            }}
          >
            Visit
          </button>
          <button class="btn ghost" onClick={() => (inviteOffer.value = null)}>
            Maybe later
          </button>
        </div>
      </div>
    );
  return null;
}
